<p-toast
  key="toast-prime-component"
  [position]="'top-right'"
  [showTransitionOptions]="'1000ms'"
  [hideTransitionOptions]="'100ms'"
  [showTransformOptions]="'translateX(100%)'"
>
  <ng-template
    pTemplate="message"
    let-message
  >
    <div
      [class]="
        'main-container flex items-start gap-spacing-xs ' + message.styleClass
      "
    >
      <i
        [ngClass]="{
          'ph-fill ph-check-circle': message.severity === 'success',
          'ph ph-info': message.severity === 'info',
          'ph ph-warning': message.severity === 'warn',
          'ph ph-x-circle': message.severity === 'error',
        }"
        class="flex align-items-center justify-content-center"
      ></i>
      <div class="flex gap-spacing-default flex-column">
        @if (message.summary.length) {
          <div class="message-title">
            {{ message.summary }}
          </div>
        }
        <div class="message-details">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
